export * from "./components/DownloadComponent";
export * from "./components/LoadingSpinner";
export * from "./constants/icons";
export * from "./constants/values";

export * from "./form/fields/PredefinedFieldSets";
export * from "./form/interface/form";
export * from "./form/interface/formContentData";
export * from "./form/interface/RequestInformation";
export * from "./form/interface/SimpleForm/Field";
export * from "./form/interface/SimpleForm/ISimpleForm";
export * from "./form/interface/SimpleForm/PredefinedBijlageField";
export * from "./form/interface/SimpleForm/PredefinedField";
export * from "./form/interface/SimpleForm/PredefinedFieldType";
export * from "./form/interface/SimpleForm/PredefinedRegelingField";
export * from "./form/interface/SimpleForm/RegelingOptions";
export * from "./form/interface/SimpleForm/Section";
export * from "./form/interface/SimpleForm/Step";
export * from "./form/mapper/CakKlantSchemaToRequestMapper";
export * from "./form/mapper/SchemaToRequestMapper";
export * from "./form/steps/StepCategoryIndicator";

export * from "./form/service/KlantContactService";

export * from "./interfaces";
export * from "./interfaces/IBaseFormulierPageProps";
export * from "./interfaces/IFormProps";
export * from "./interfaces/submit-formulier-results";
export * from "./locales/src/translate";
export * from "./mapper/response-mapper-formulier";
export * from "./utils/file-mock";
export * from "./utils/file-to-upload";

export * from "./form/interface/SimpleForm/RegelingOptions";

import * as FormulierPageModule from "./page/FormulierPage";
export const FormulierPage = FormulierPageModule.default;

import { en } from "./locales/src/en";
import { nl } from "./locales/src/nl";
export const nlKlantondersteuningLanguageSet = nl;
export const enKlantondersteuningLanguageSet = en;
